import FilesDownloadForm from './download-settlement-file-form'

export const CreateSettlementFile = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <FilesDownloadForm onCloseModal={onCloseModal} />
}
